import "./styles.scss";
import { BsPersonCircle } from "react-icons/bs";
import { GetUserProfileData, UserProfileDTO } from "./tenantApiCall";
import { useEffect, useState } from "react";
import { getActiveTenantName } from "../../Logic/Auth/TokenManager";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";

function General() {
    const [userProfile, setUserProfile] = useState<UserProfileDTO>();
    const UserInfo = useSelector((state: RootState) => state.UserInformation);

    useEffect(() => {
        const fetchUserData = async () => {
            const response = await GetUserProfileData();
            if (!response.isOk || !response.data) return;

            setUserProfile(response.data);
        };

        fetchUserData();
    }, []);

    return (
        <>
            <div className="header">Details</div>
            <div style={{ padding: "20px", paddingTop: "13px" }}>
                <div className="row">
                    <div className="col-sm-12 userPrefViewedHeader">
                        <div className="profile-container">
                            <div className="user-info-row">
                                <BsPersonCircle
                                    size={80}
                                    className="user-icon"
                                />
                                <div className="user-details">
                                    <p>
                                        <strong>{userProfile?.firstName + " " + userProfile?.lastName}</strong>
                                    </p>
                                    <p>
                                        <span>Email: {userProfile?.email}</span>
                                    </p>
                                    <p>
                                        <span>Alias: {userProfile?.externalUserID}</span>
                                    </p>
                                </div>
                            </div>

                            <div className="profile-description">
                                <table className="roles-table">
                                    <thead>
                                        <tr>
                                            <th>Profile Description</th>
                                            <th>Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Tenant</td>
                                            <td>{getActiveTenantName(false)}</td>
                                        </tr>
                                        <tr>
                                            <td>Department</td>
                                            <td>{userProfile?.departmentName}</td>
                                        </tr>

                                        <tr>
                                            <td>Global Role</td>
                                            <td>{userProfile?.globalRoleName}</td>
                                        </tr>
                                        <tr>
                                            <td>Job Title</td>
                                            <td>{UserInfo.jobTitle}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <table className="roles-table">
                                <thead>
                                    <tr>
                                        <th>Department</th>
                                        <th>Mailbox</th>
                                        <th>Role</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userProfile?.mailboxMembership
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.departmentName < b.departmentName) return -1;
                                            if (a.departmentName > b.departmentName) return 1;

                                            if (a.mailboxName < b.mailboxName) return -1;
                                            if (a.mailboxName > b.mailboxName) return 1;

                                            return 0;
                                        })
                                        .map((role: any) => (
                                            <tr>
                                                <td>{role.departmentName}</td>
                                                <td>{role.mailboxName}</td>
                                                <td>{role.roleName}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <br></br>
                <div className="row">
                    <div className="col-sm-5"></div>
                    <div className="col-sm-7"></div>
                </div>
            </div>
        </>
    );
}
export default General;
